import { useState, useEffect, useRef, useCallback } from 'react';
import { ORIGINAL_START } from '../../data/fifty2Tuesdays';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/fifty2`;
const put = (url, body) => fetch(url, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });

// Date of week n counted from a YYYY-MM-DD start (local time)
export const weekDate = (start, n) => {
  const [y, m, d] = (start || ORIGINAL_START).split('-').map(Number);
  return new Date(y, m - 1, d + 7 * (n - 1));
};
export const fmtDate = (dt) => dt.toLocaleDateString(undefined, { month: 'long', day: 'numeric', year: 'numeric' });
export const startsMonth = (start, n) => n === 1 || weekDate(start, n).getMonth() !== weekDate(start, n - 1).getMonth();

export default function useFifty2Progress(userId) {
  const [progress, setProgress] = useState({ start_date: null, show_dates: false, weeks: {} });
  const [status, setStatus] = useState({ week: null, state: 'idle' });
  const timers = useRef({});

  useEffect(() => {
    if (!userId) return;
    fetch(`${API}/progress?user_id=${encodeURIComponent(userId)}`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => d && setProgress({ weeks: {}, ...d }))
      .catch(() => {});
  }, [userId]);

  const saveSettings = useCallback((settings) => {
    setProgress((p) => ({ ...p, ...settings }));
    if (userId) put(`${API}/settings`, { user_id: userId, ...settings }).catch(() => {});
  }, [userId]);

  const patchWeek = (n, data) => setProgress((p) => ({ ...p, weeks: { ...p.weeks, [n]: { ...(p.weeks[n] || {}), ...data } } }));

  const setReflection = useCallback((n, reflection) => {
    patchWeek(n, { reflection });
    setStatus({ week: n, state: 'saving' });
    clearTimeout(timers.current[n]);
    timers.current[n] = setTimeout(async () => {
      try {
        const res = await put(`${API}/week/${n}`, { user_id: userId, reflection });
        setStatus((s) => (s.week === n ? { week: n, state: res.ok ? 'saved' : 'error' } : s));
      } catch { setStatus((s) => (s.week === n ? { week: n, state: 'error' } : s)); }
    }, 800);
  }, [userId]);

  const setCompleted = useCallback(async (n, completed) => {
    const res = await put(`${API}/week/${n}`, { user_id: userId, completed }).catch(() => null);
    if (res?.ok) patchWeek(n, (await res.json()).week);
  }, [userId]);

  return { progress, status, saveSettings, setReflection, setCompleted };
}
